import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { supportsDeviceChange } from '../../../../../../helpers/browser-capabilities';
import { selectIsUserIODiagnosticsEnabled } from '../../../../../flags/selectors';
import { SoundStub } from './sound-stub';
import { SoundSupported } from './sound-supported';
import { SoundWithDiagnostic } from './sound-with-diagnostic';

export const SoundSection: FunctionComponent = () => {
    const isDiagnosticAvailable = useSelector(selectIsUserIODiagnosticsEnabled);

    if (!supportsDeviceChange()) {
        return <SoundStub />;
    }

    return isDiagnosticAvailable ? <SoundWithDiagnostic /> : <SoundSupported />;
};
